import { createAction } from "redux-actions";
import { GET_PRECALIFICACION } from "../constants";
import { feathersFindDataAll } from "../services";

export const getPreCalificacion = createAction(GET_PRECALIFICACION, (user) => feathersFindDataAll('precalificacion',{ user })())